import { ReportStatuses } from '@dashboard-experience/utils';

import { ReportSummary } from 'api/candidates/types/Report';

// Keeps the upsell away from candidates in an adverse state (consider, dispute,
// canceled, closed).
const ELIGIBLE_REPORT_STATUSES: string[] = [
  ReportStatuses.CLEAR,
  ReportStatuses.COMPLETE,
  ReportStatuses.SUSPENDED,
  ReportStatuses.PENDING,
];

/**
 * Whether the report the banner is about is in a status we're willing to
 * promote Checkr Personal against. Compares lowercased, like ReviewCTABanner,
 * since redux holds these reports untyped.
 */
export const hasEligibleReportStatus = (
  report: ReportSummary | undefined,
): boolean => {
  const displayStatus = report?.displayStatus?.toLowerCase();
  const status = report?.status?.toLowerCase();
  return (
    (!!displayStatus && ELIGIBLE_REPORT_STATUSES.includes(displayStatus)) ||
    (!!status && ELIGIBLE_REPORT_STATUSES.includes(status))
  );
};

/**
 * Returns the most recently touched report (by `lastTouchedAt`), which is the
 * report the banner's visibility and CTA both key off of. Returns undefined
 * when there are no reports. Keep this as the single way to pick "the report"
 * so visibility and the auth URL's `candidate_id` never disagree.
 */
const touchedAt = (report: ReportSummary): number => {
  const time = new Date(report.lastTouchedAt).getTime();
  return Number.isNaN(time) ? 0 : time;
};

export const getLatestReport = (
  reports: ReportSummary[] | undefined,
): ReportSummary | undefined => {
  if (!reports || !reports.length) return undefined;
  return [...reports].sort((a, b) => touchedAt(b) - touchedAt(a))[0];
};
